import { gql, useQuery } from '@apollo/client';

import type { GraphQLTypes } from 'src/lib/graphqlTypes';

export const useIsLoggedIn = () => {
  const { data } = useQuery(gql<
    GraphQLTypes.UseIsLoggedInQuery,
    GraphQLTypes.UseIsLoggedInQueryVariables
  >/* GraphQL */ `
    query UseIsLoggedInQuery {
      isLoggedIn @client
    }
  `);

  return {
    isLoggedIn: !!data?.isLoggedIn,
    loading: typeof data?.isLoggedIn !== 'boolean',
  };
};
